import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import Chest from "../assets/img/chest-404.png";
import { Context } from '../context/Products';
import Helmet from '../components/Helmet';
import { seo } from '../assets/dummyData/seo';

const copy = {
    ka: {
        title: "გვერდი ვერ მოიძებნა",
        text: <>ეს ზანდუკი ცარიელია. <br /> გვერდი, რომელსაც ეძებთ, რუკაზე ვერ მოიძებნა. <br /> დაბრუნდით მთავარ გვერდზე.</>,
        button: "მთავარი გვერდი",
    },
    en: {
        title: "Page not found",
        text: <>This chest is empty. <br /> The page you are looking for could not be found on the map. <br /> Continue to the homepage.</>,
        button: "Homepage",
    },
};

const PageNotFound = () => {
  const [{ lang }] = useContext(Context);
  const text = copy[lang] || copy.en;
  return (
    <div id="page-404" className="page fade-onload">
        <Helmet title={seo[lang].notFound.title} metaDesc={seo[lang].notFound.description} lang={lang} />
        <div className="container-custom">
            <div className="visible-xs">
                <img src={Chest} alt="404" className="chest" />
            </div>
            <div className="hidden-xs">
                <div className="chest"></div>
            </div>
            <div className="content">
                <h1 className="page-heading fade-onload">
                {text.title}
                </h1>
                <p>
                    {text.text}
                </p>
                
                <div className="btn-wrap" style={{ marginTop: "60px" }}>
                    <Link to="/" className="btn btn-primary">{text.button}</Link>
                </div>
            </div>
        </div>
    </div>
  )
}

export default PageNotFound;
